import * as THREE from 'three'

/* eslint-disable */
const leafShape = new THREE.Shape([
  [ -2, -15],
  [ -1,  -7],
  [ -4,  -7],
  [-12,   0],
  [ -7,   0],
  [-10,   8],
  [ -4,   6],
  [  0,  15],
  [  4,   6],
  [ 10,   8],
  [  7,   0],
  [ 12,   0],
  [  4,  -7],
  [  1,  -7],
  [  2, -15]
].map(([x, y]) => new THREE.Vector2(x, y)))
/* eslint-enable */

export default class LeafGeometry extends THREE.ShapeBufferGeometry {
  constructor () {
    super(leafShape)
  }
}
